/**
 * Extracts only the relevant fields from the HTTP response.
 * @param {Object} res - The HTTP response object.
 * @returns {Object} An object containing the extracted results, headers, and status.
 */
export const transformRequestRes = (res) => {
  return {
    results: res.data.results ? res.data.results : res.data,
    headers: res.headers.toJSON(),
    status: res.status,
  };
};

/**
 * Builds a URL with query parameters if filters are provided.
 *
 * @param {string} url - The base URL without query parameters.
 * @param {object} filters - An object containing key-value pairs to include as query parameters.
 * @returns {string} - The complete URL with filters applied (if any).
 */
export const buildUrlWithFilters = (url, filters) => {
  if (!filters) return url;

  const queryString = new URLSearchParams(filters).toString();
  return `${url}?${queryString}`;
};

/**
 * Removes properties with `undefined` values from an object.
 *
 * @param {object} obj - The object to filter.
 * @returns {object} - A new object with the properties that do not have `undefined` values.
 */
export const removeNullValues = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => value !== undefined)
  );
};
